import Picker from '../picker'
import DatePanel from '../panel/date'
import DateRangePanel from '../panel/date-range'
import MonthRangePanel from '../panel/month-range'

const getPanel = function (type) {
  if (type === 'daterange' || type === 'datetimerange' || type === 'weekrange') {
    return DateRangePanel
  } else if (type === 'monthrange') {
    return MonthRangePanel
  }
  return DatePanel
}

export default {
  mixins: [Picker],

  name: 'KyeDatePicker3',

  props: {
    type: {
      type: String,
      default: 'date'
    },
    timeArrowControl: Boolean,
    // 展示“此刻”按钮
    showNowOption: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    type(type) {
      if (this.picker) {
        this.unmountPicker()
        this.panel = getPanel(type)
        this.mountPicker()
      } else {
        this.panel = getPanel(type)
      }
    }
  },

  created() {
    this.panel = getPanel(this.type)
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-date-picker3/src/picker/date-picker.js